var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("desc", null, "Created with Fabric.js 5.2.4");

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("defs", null);

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  transform: "matrix(1 0 0 1 540 540)",
  id: "fef6cc3b-0b32-4790-a7e6-7bc3fd88c268"
});

var SvgAcceptMatchButton = function SvgAcceptMatchButton(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "ff150772-62ef-4055-8617-f1bce2517400"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), _ref4, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(21.18 0 0 21.18 540 540)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0)",
    id: "Oval"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(128,207,9)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    cx: 0,
    cy: 0,
    r: 25.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -4.69 -1.55)",
    id: "Fill-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-7.81, -11.95)",
    d: "M 3.03582857 19.9024744 L 2.21068571 19.9024744 C 1.21582857 19.9024744 0.408971429 19.1104744 0.408971429 18.132614 C 0.408971429 17.1553116 1.21582857 16.3633116 2.21068571 16.3633116 L 1.80325714 16.3633116 C 0.806685714 16.3633116 0.0004 15.5707535 0.0004 14.5934512 C 0.0004 13.6161488 0.806685714 12.8235907 1.80154286 12.8235907 L 2.62897143 12.8235907 C 1.63354286 12.8235907 0.827257143 12.0310326 0.827257143 11.0537302 C 0.827257143 10.076986 1.63354286 9.28442791 2.62897143 9.28442791 L 8.12097143 9.28442791 C 7.2844 7.22545116 6.57868571 4.73168372 7.54725714 1.7060093 C 7.84554286 0.773916279 8.8564 0.255404651 9.80554286 0.548427907 C 10.7546857 0.841451163 11.1598286 1.80535814 10.9838286 2.7675907 C 10.1238286 7.47270698 15.6181143 9.01428837 15.6181143 10.6351256 L 15.6181143 21.6790326 C 15.6181143 21.9279628 15.4569714 22.1501023 15.2169714 22.2338233 C 14.2152571 22.5804279 11.5741143 23.4416372 10.0238286 23.4416372 L 3.03582857 23.4416372 C 2.04097143 23.4416372 1.23468571 22.6496372 1.23468571 21.6723349 C 1.23468571 20.6950326 2.04097143 19.9024744 3.03582857 19.9024744",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 8.5 3)",
    id: "Fill-4"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-21, -16.5)",
    d: "M 18.1527121 22.0266115 C 18.1527121 21.5446481 18.5182197 21.1537552 18.9694019 21.1537552 C 19.4200278 21.1537552 19.7855355 21.5446481 19.7855355 22.0266115 C 19.7855355 22.5085748 19.4200278 22.8994678 18.9694019 22.8994678 C 18.5182197 22.8994678 18.1527121 22.5085748 18.1527121 22.0266115 L 18.1527121 22.0266115 Z M 17 23.0159669 C 17 23.5594323 17.4144645 24 17.9257302 24 L 24.0742698 24 C 24.5855355 24 25 23.5594323 25 23.0159669 L 25 9.98403312 C 25 9.44056771 24.5855355 9 24.0742698 9 L 17.9257302 9 C 17.4144645 9 17 9.44056771 17 9.98403312 L 17 23.0159669 Z",
    strokeLinecap: "round"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAcceptMatchButton, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/accept-match-button.ab29e82d.svg";
export { ForwardRef as ReactComponent };